import { BrowserModule } from '@angular/platform-browser';
import {LOCALE_ID, NgModule} from '@angular/core';


import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {Routes} from '@angular/router';
import { CalendarComponent } from './calendar/calendar.component';
import {HttpClientModule} from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import { CoursesGroupsComponent } from './courses-groups/courses-groups.component';
import { CoursesGroupComponent } from './course-group/courses-group.component';
import { RoundsComponent } from './calendar/rounds/rounds.component';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import {MatTooltipModule} from '@angular/material';

import localePl from '@angular/common/locales/pl';
import { CourseComponent } from './course/course.component';
import { DayOfWeekPipe } from './day-of-week.pipe';
import { RegistrationComponent } from './calendar/registration/registration.component';
import { ClassgroupComponent } from './classgroup/classgroup.component';
import { InfoBoxComponent } from './info-box/info-box.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { EncodePipe } from './encode.pipe';
import { TipComponent } from './tip/tip.component';
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import { BadgeComponent } from './badge/badge.component';

registerLocaleData(localePl, 'pl');

const routes: Routes = [];

@NgModule({
  declarations: [
    AppComponent,
    CalendarComponent,
    CoursesGroupsComponent,
    CoursesGroupComponent,
    RoundsComponent,
    CourseComponent,
    DayOfWeekPipe,
    RegistrationComponent,
    ClassgroupComponent,
    InfoBoxComponent,
    EncodePipe,
    TipComponent,
    BadgeComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    MatTooltipModule,
    NgbModule,
    MatProgressSpinnerModule,
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'pl' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
